module.exports = __webpack_public_path__ + "img/menu.2f16dfba.svg";